export default __webpack_public_path__ + "static/media/Itad_destruciton.837561e8.png";